import React from 'react';

export const useHorariosBloqueadosParaUnidade = (horariosBloqueados, horariosUsadosPorUnidade, unidadeSelecionada) => {
	return React.useMemo(() => {
		if (!horariosBloqueados || !horariosUsadosPorUnidade || !unidadeSelecionada) return [];
		return [...new Set(horariosBloqueados.concat(horariosUsadosPorUnidade.get(unidadeSelecionada.id) || []))];
	}, [horariosBloqueados, horariosUsadosPorUnidade, unidadeSelecionada]);
};
